import React from 'react'
import { useTranslation } from 'react-i18next'

import { Direction } from '../../../../hooks/usePagination'
import { NavigationDirection } from '../../../../types/navigationDirection'
import { Button } from '../../../Button'
import { ButtonsGroup } from '../../../ButtonsGroup'
import { FileButton } from '../../../FileButton'
import { FloatingActionsMenuProps } from '../../types'
import { FloatingActionsPanel } from '../FloatingActionsPanel'
import * as Styled from './styles'

interface FileActionsProps {
  activePageNumber: number
  actionsMenuItems?: (props: FloatingActionsMenuProps) => React.ReactNode
  canChangePage: (direction: Direction) => boolean
  handleChangePage: (direction: Direction) => void
  handleDeleteClick: () => void
  handleDownloadClick: () => void
  handleRotateClick: () => void
  handleFileSelect: (files: File[]) => void
  floatingActionsPanelPosition?: string
  isFloatingActionsView?: boolean
  isInView: boolean
  isLoading: boolean
  navigationDirection: NavigationDirection
  onImageZoomClick?: () => void
  pagesAmount: number
  shouldRenderNavigation: boolean
  withDeleteButton?: boolean
  withDownloadButton?: boolean
  withEditButton: boolean
  withModalZoom: boolean
  withPagination: boolean
  withRotate: boolean
  zoomable: boolean
}

export const FileActions = (props: FileActionsProps) => {
  const {
    handleDeleteClick,
    handleDownloadClick,
    handleFileSelect,
    handleRotateClick,
    isFloatingActionsView = false,
    onImageZoomClick,
    withDeleteButton,
    withDownloadButton,
    withEditButton,
    withModalZoom,
    withRotate,
  } = props
  const { t } = useTranslation()

  const ButtonsView = (
    <ButtonsGroup>
      {withRotate && (
        <Button icon="rotateSquare" onClick={handleRotateClick} size="sm" title={t('rotate')} variant="tonal" />
      )}
      {withDownloadButton && (
        <Button icon="download" onClick={handleDownloadClick} size="sm" title={t('download')} variant="tonal" />
      )}
      {withEditButton && (
        <FileButton icon="squarePen" size="sm" title={t('edit')} variant="tonal" onFilesSelect={handleFileSelect} />
      )}
      {withModalZoom && (
        <Button icon="zoomIn" onClick={onImageZoomClick} size="sm" title={t('full_screen')} variant="tonal" />
      )}
      {withDeleteButton && (
        <Button icon="trash" onClick={handleDeleteClick} size="sm" title={t('delete')} variant="tonal" />
      )}
    </ButtonsGroup>
  )

  return isFloatingActionsView ? (
    <FloatingActionsPanel {...props} />
  ) : (
    <Styled.ActionsWrapper>{ButtonsView}</Styled.ActionsWrapper>
  )
}
